/** @format */
import { MarketSlug } from '@mpb-com/feather/enums';
import { TFunction } from 'i18next';
import { capitalize } from 'lodash';

import {
    centToDecimal,
    formatAsCurrency,
} from '@toucan/client/global/currency';
import { Market } from '@toucan/client/global/market';
import { Model } from '@toucan/client/global/model';

import { CatalogueModelNode, CatalogueModelSpecNode } from './types';

/**
 * It is possible for newPrice to be "N/A" so it should fallback to 0 for all non-numbers when converting newPrice into price
 */
export const convertModelNewPriceToPrice = (newPrice: Model['newPrice']) => {
    const newPriceAsNumber = Number(newPrice);
    return isNaN(newPriceAsNumber) ? 0 : newPriceAsNumber;
};

export const getModelHrefFromSlug = (
    t: TFunction,
    marketSlug: MarketSlug,
    modelSlug: string,
    sku?: string
) => {
    const href = `/${marketSlug}/${t('product', {
        ns: 'urls',
    })}/${modelSlug}`;

    return sku ? `${href}/sku-${sku}` : href;
};

export const formatModelPrice = (activeMarket: Market) => (price: number) =>
    formatAsCurrency(activeMarket.iso, activeMarket.currency)(
        centToDecimal(price),
        { trailingZeros: false }
    );

export const getCatalogueModelListPrice = (
    prices: CatalogueModelNode['prices']
): string => {
    const price = prices?.[0]?.buyValue.value;
    return price ? centToDecimal(price).toString() : '';
};

export const getSpecValues = (
    spec: CatalogueModelSpecNode
): { value: string | boolean | null; displayValue: string | number } => {
    switch (spec.type) {
        case 'NUMERIC':
            return { value: '', displayValue: spec.numericValue as number };
        case 'BOOLEAN':
            return {
                value:
                    spec.boolValue !== null
                        ? capitalize(spec.boolValue.toString())
                        : spec.boolValue,
                displayValue: '',
            };
        case 'PHRASE':
            return {
                value: '',
                displayValue: spec.phraseTranslations[0]?.value ?? '',
            };
        default:
            return { value: '', displayValue: '' };
    }
};
